export default __webpack_public_path__ + "static/media/abstract8.0928bb4e.jpg";